// Chakra imports
import {
  Flex,
  Text,
  Avatar,
  useColorModeValue,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
import Camera from "views/admin/atendimento/profile/components/Camera";
import { MdCheck } from "react-icons/md";
import { isEmpty } from "@chakra-ui/utils";
import { IsEmpty } from "config/functions";

export default function Profile(props: {
  dataUser: any;
  handleFotoIndex: any;
  cpfBusca: any;
  fotoAlteradaUserData: any;
  protocolo: any;
}) {
  const {
    dataUser,
    handleFotoIndex,
    fotoAlteradaUserData,
    protocolo,
    cpfBusca,
  } = props;
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const imageData = dataUser.base64Imagem || "";
  //const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalOpen, setModalOpen] = useState(false);
  const finalRef = React.useRef(null);
  const [fotoNova, setFotoNova] = useState("");
  const [protocoloNovo, setProtocoloNovo] = useState("");
  const [disabledConfirmar, setDisabledConfirmar] = useState(true);
  const [modalFaceOpen, setModalFaceOpen] = useState(false);
  const [handleFotoNova, setHandleFotoNova] = useState("");

  useEffect(() => {
    setFotoNova("");
    setHandleFotoNova("");

    setProtocoloNovo(protocolo?.id ?? protocolo);
  }, [protocolo]);

  const handleFoto = (foto: any) => {
    if (!isEmpty(foto)) {
      setHandleFotoNova(foto);
      handleFotoIndex(foto);
      setDisabledConfirmar(false);
    } else {
      setDisabledConfirmar(true);
    }
  };

  const onConfirm = () => {
    if (!isEmpty(handleFotoNova)) {
      setFotoNova(handleFotoNova);
      handleFotoIndex(handleFotoNova.replace("data:image/jpeg;base64,", ""));
      setModalOpen(false);
      setDisabledConfirmar(true);
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
    } else {
      setDisabledConfirmar(true);
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
    }
  };
  const onClose = () => {
    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2").style.display = "block";
    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2").style.display = "block";
    setModalOpen(false);
    setModalFaceOpen(false);
  };
  const onOpen = () => {
    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2").style.display = "none";
    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2").style.display = "none";
    setDisabledConfirmar(true);
    setModalOpen(true);
  };

  const handleClickSetModalFace = () => {
    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2").style.display = "none";
    setModalFaceOpen(true);
  };

  // useEffect(() => {
  //   imageData = fotoAlteradaUserData;
  //   setFotoNova(fotoAlteradaUserData);
  // }, [fotoAlteradaUserData]);

  // Chakra Color Mode
  return (
    <>
      <Flex align="center" direction="row">
        <Avatar
          src={
            fotoNova
              ? "data:image/jpeg;base64," + fotoNova
              : `data:image/jpeg;base64,${imageData}`
          }
          h="67px"
          w="67px"
          me="20px"
          style={{ cursor: "pointer" }}
          onClick={handleClickSetModalFace}
        ></Avatar>

        <Flex direction="column">
          <Text color={textColorPrimary} fontWeight="bold" fontSize="sm">
            {dataUser.nome}
          </Text>
          {/* <Button
            variant="darkBrand"
            fontSize="small"
            borderRadius="16px"
            p="12px"
            height={"20px"}
            mt="5px"
            disabled={IsEmpty(dataUser) ? true : false}
            leftIcon={<MdCameraAlt size="17px" />}
            onClick={onOpen}
          >
            {imageData ? "Editar foto" : "Tirar foto"}
          </Button> */}
          {/* <Text color={textColorPrimary} fontWeight="bold" fontSize="lg">
            Protocolo: {protocolo?.id ?? protocolo}
          </Text> */}
        </Flex>
      </Flex>

      <Modal finalFocusRef={finalRef} isOpen={modalOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          style={{ height: "600px", width: "800px" }}
          alignSelf={"center"}
        >
          <ModalHeader>Biometria Facial</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex
              justify="flex-start"
              h={IsEmpty(dataUser) ? "0px" : "0px"}
              w={"100%"}
              height={"200px"}
            >
              <Camera
                dataUser={dataUser}
                handleFoto={handleFoto}
                cpfBusca={cpfBusca}
                cep={0}
                dtNascimento={0}
                nomeUser={0}
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="brand" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              leftIcon={<MdCheck />}
              colorScheme="brand"
              onClick={onConfirm}
              disabled={disabledConfirmar}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal finalFocusRef={finalRef} isOpen={modalFaceOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          style={{ height: "600px", width: "100%" }}
          alignSelf={"center"}
        >
          <ModalHeader>Biometria Facial</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex
              justify="center"
              h={IsEmpty(dataUser) ? "0px" : "0px"}
              w={"100%"}
              height={"200px"}
            >
              <Avatar
                src={
                  fotoNova
                    ? "data:image/jpeg;base64," + fotoNova
                    : `data:image/jpeg;base64,${imageData}`
                }
                h="437px"
                w="437px"
                border={
                  window.config.tenant === "Jae"
                    ? "7px solid #5db6cb"
                    : "7px solid #2A85BD"
                }
              ></Avatar>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="brand" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
